import axios from 'axios';

export const HTTP = axios.create({
    baseURL: `${window.location.protocol}//${window.location.host}`,
    // xsrfHeaderName: "X-CSRFTOKEN",
    // xsrfCookieName: "csrftoken",
});